<template>
  <div>
    <b-modal
      id="pre-departure-info-modal"
      ref="pre-departure-info-modal-ref"
      hide-footer
      title="Pre-departure Information"
    >
      <div v-if="pdiContent">
        <h4>Booking Number: {{bookingNumber}}</h4>
        <b-list-group class="mt-3">
          <b-list-group-item v-for="(item, key) in pdiContent" :key="key" @click="showModal">
            <b-link v-b-toggle="'email-info-'+key" style="color:lightgreen">
              <span v-if="key===0 && pdiContent.length>1">Are you ready?</span>
              <span v-else> Next Steps - sent to {{item.email}} on {{new Date(item.created).toLocaleDateString()}}</span>
            </b-link>
            <b-collapse
              :id="`email-info-${key}`"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div class="mt-2">
                <p> We have sent your pre-departure information in an email to {{pdiContent[key].email}}<br>Here it is again:</p>
                <div v-html="pdiContent[key].body" />
              </div>
            </b-collapse>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { loadPDIHtml } from "./services";

export default {
  data() {
    return { pdiContent: [] };
  },
  computed:{
      bookingNumber() {
        return this.$store.getters["booking/getBookingNumber"];
      },
      bookingInfo() {
        return this.$store.getters["booking/getBookingInfo"];
      }
  },
  methods: {
    async showModal() {
      this.$refs["pre-departure-info-modal-ref"].show();
       // Show loading spinner
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
      this.pdiContent = await loadPDIHtml(this.bookingInfo.lead_surname,this.bookingNumber);
      this.$store.dispatch("spinner/updateLoadingAction", false, {
        root: true,
      });
    }
  },
};
</script>

<style>
</style>
